import { SET_AUTH_TOKEN } from 'redux/actionTypes';

export default function authToken(state = "", action) {
    switch(action.type) {
        case SET_AUTH_TOKEN:
            return action.payload;
        default:
            return state;
    }
};